import React from "react";
import { FaFacebookSquare } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { BiLogoGithub } from "react-icons/bi";
import { VscSend } from "react-icons/vsc";
import MyImage from "../../src/imgs/profilepic.JPG";
import "animate.css";
import "./main.css";
import ScrollDown from "./ScrollDown";
import { Typewriter } from "react-simple-typewriter";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <div className="header" id="home">
        <div className="headerCon">
          <div className="headIcons animate__animated animate__fadeInDown">
            <a
              href="https://www.linkedin.com/in/emilyh0212"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className="headIcon" />
            </a>
            <a
              href="https://github.com/emilyh0212"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BiLogoGithub className="headIcon" />
            </a>
          </div>

          <h1 className="head animate__animated animate__fadeInLeft">
            Emily Han
          </h1>

          <p className="subHead animate__animated animate__fadeInRight">
            I'm a
            <Typewriter
              words={[
                " Product Manager",
                " Problem Solver",
                " User Advocate",
                " Team Leader",
              ]}
              loop="infinite"
              cursor
              cursorStyle="|"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </p>

          <p style={{marginBottom: "2rem"}} className="subPara animate__animated animate__fadeInRight">
            Product Manager and technical builder passionate about AI/ML and
            product execution. Experienced in driving end-to-end development
            from ideation to launch, turning complex problems into scalable
            solutions that serve real users.
          </p>

          <div className="headBtn">
            <Link
              to="/"
              className="mainBtn animate__animated animate__fadeInUp"
              style={{ marginTop: "20px" }} // "!important" ki zarurat nahi React mein
            >
              <VscSend className="btnSpan" style={{ transform: "rotate(180deg)", marginRight: "8px" }} />
              Back to chat
            </Link>
          </div>

        </div>

        <div className="headerImg">
          <img src={MyImage} alt="" />
        </div>
      </div>
      <ScrollDown />
    </>
  );
};

export default Header;
